import * as authAPI from '@debbie/cortex/dist/api/auth.js';
import React, { useState } from 'react';
import Reset from './password_reset/Reset.js';
import TokenInput from './password_reset/TokenInput.js';
import Update from './password_reset/Update.js';
var View;
(function (View) {
    View[View["Reset"] = 0] = "Reset";
    View[View["TokenInput"] = 1] = "TokenInput";
    View[View["Update"] = 2] = "Update";
    View[View["Loading"] = 3] = "Loading";
})(View || (View = {}));
const PasswordReset = (props) => {
    const [view, setView] = useState(View.Reset);
    const [error, setError] = useState('');
    const [username, setUsername] = useState('');
    const [resetToken, setResetToken] = useState('');
    const onReset = (username) => {
        setUsername(username);
        setView(View.TokenInput);
    };
    const onVerify = (resetToken) => {
        setResetToken(resetToken);
        setView(View.Update);
    };
    const onUpdate = async (password) => {
        try {
            await authAPI.updatePassword(username, resetToken, password);
            props.onUpdated();
        }
        catch (err) {
            console.error(err);
            setError(err.message);
            setView(View.TokenInput);
        }
    };
    return (React.createElement("div", null,
        error !== '' && React.createElement("div", { className: "warning" }, error),
        view === View.Reset ? (React.createElement(Reset, { onReset: onReset, onCancel: props.onCancel })) : view === View.TokenInput ? (React.createElement(TokenInput, { onSubmit: onVerify, onCancel: props.onCancel })) : (React.createElement(Update, { onUpdate: onUpdate, onCancel: props.onCancel }))));
};
export default PasswordReset;
//# sourceMappingURL=PasswordReset.js.map